// const apiDomain = "https://flyhighapi.dgmonglab.com" //개발서버
const apiDomain = "https://api.cubalto.com" //실서버
const apiURL = `${apiDomain}/api/`;

export {apiURL, apiDomain};